import React, { Component, push } from "react";
import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Layer,
  Tip,
  Spinner,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Console,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Close,
} from "grommet-icons";
import { SingleSelect } from "react-select-material-ui";
import { hpe as theme } from "grommet-theme-hpe";
import auth from "./Security/Auth";
import {
  callApiGetJson,
  callApiPostJson,
  OnDemandRefreshInterval,
  callApiGetJsonwithEP,
  logAccess,
} from "./GlobalSettings";
import Launchdemospinner from "./Launchdemospinner";
import InfoWarning from "./InfoWarning";

class LaunchLiveDemo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eventTypeData: undefined,
      demoEvtTypeVal: "Select Event Type",
      isEvtListDisabled: true,
      EvtTypeSelected: undefined,
      DemoData: this.props.demo,
      OppID: undefined,
      CustomerName: undefined,
      NoOppIDChecked: false,
      showSFDCValidating: false,
      errorInValidation: false,
      stickMessage: undefined,
      NoOppIDReason: undefined,
      UserInfo: auth.getUserInfo(),
      bShowEvtCreationOnDemandLoader: false,
      bTriggerActiveDemosCall: false,
      bShowDupeEvtOverlay: false,
      DupeMsg: undefined,
      isGLusrVerified: false,
      SubmitLabel: "Validate Opp ID",
    };

    this.loadEventTypes = this.loadEventTypes.bind(this);
    this.handleDemoEventTypeChange = this.handleDemoEventTypeChange.bind(this);
    this._handleEventRequestOnDemand =
      this._handleEventRequestOnDemand.bind(this);
    this.handleOppID = this.handleOppID.bind(this);
    this.handleCustomerName = this.handleCustomerName.bind(this);
    this.setOppIDChecked = this.setOppIDChecked.bind(this);
    this._onSFDCOpptyIdSubmit = this._onSFDCOpptyIdSubmit.bind(this);
    this._HideLauncher = this._HideLauncher.bind(this);
    this._hideInfoWarning = this._hideInfoWarning.bind(this);
  }

  componentDidMount() {
    this.loadEventTypes();
  }

  handleOppID(value) {
    console.log("OPP ID Changed with value ", value);
    if (value.length > 3) {
      this.setState({ SubmitLabel: "Validate Opp ID" });
    }
    this.setState({ OppID: value });
  }

  _hideInfoWarning() {
    this.setState({ bShowDupeEvtOverlay: false, bshowGLUsrwarning: false });
    this.props.hide();
  }

  _HideLauncher() {
    this.setState({ bTriggerActiveDemosCall: false });
    this.props.hide();
  }

  setOppIDChecked(value) {
    console.log("NO Opp ID Checkbox value is ", value);
    this.setState({ NoOppIDChecked: value });
    if (value) {
      console.log("Now OppID value should be reset to null");
      this.setState({
        NoOppIDReason: "I do not have Opp ID",
        //OppID: undefined,
      });
      this.setState({
        // NoOppIDReason: "I do not have Opp ID"
        OppID: null,
      });
    } else {
      console.log("Now OppID value should not be reset to null");
      this.setState({ NoOppIDReason: undefined });
    }
    console.log("OppID text value is ", this.state.OppID);
  }

  handleCustomerName(value) {
    console.log("Customer Name with value ", value);
    //var SFDCtoBeShown = true;
    if (this.state.UserInfo.UserAppRoles) {
      var CustOne = this.state.UserInfo.UserAppRoles.find(
        (ar) => ar.AppRoleName === "HPE Customer",
      );
      if (CustOne !== undefined) {
        console.log("Customer App Role Obj is", CustOne);
        this.setState({
          CustomerName: value,
          NoOppIDChecked: true,
          NoOppIDReason: "I do not have Opp ID",
        });
      } else {
        this.setState({ CustomerName: value });
      }
    }
    //this.setState({ CustomerName: value });
  }

  _handleEventRequestOnDemand() {
    var date = new Date();
    var d = new Date();
    var isLogged = false;
    d.toISOString();
    d.setHours(d.getHours() + 2);

    auth.verifyToken();
    let token = auth.getToken();
    var endpoint = "/Events/OnDemandNow";

    if (
      this.state.EvtTypeSelected &&
      this.state.CustomerName &&
      (this.state.NoOppIDChecked ? this.state.NoOppIDReason : this.state.OppID)
    ) {
      var evtObj = {
        Event_ID: 0,
        Event_Type: {
          EventType_ID: this.state.EvtTypeSelected.EventType_ID,
          EventType_Name: this.state.EvtTypeSelected.EventType_Name,
          EventType_Enabled: true,
        },
        Event_DeliveryLocation: {
          EventDeliveryLocation_ID: 6,
          EventDeliveryLocation_Name: "Your Local Address",
          EventDeliveryLocation_Enabled: true,
        },
        Event_Requester: null,
        Event_Presenter: { EmailAddress: this.state.UserInfo.EmailAddress },
        Event_OpportunityID:
          this.state.OppID && this.state.OppID.length > 1
            ? this.state.OppID
            : null,
        Event_Duration: { Duration_ID: "0.2:00", Duration_Name: null },
        Event_CustomerName: this.state.CustomerName,
        Event_StartDate: date.toISOString(),
        Event_EndDate: d.toISOString(),
        Event_Status: { EventStatus_ID: 1 },
        Event_Title: "On-Demand - " + this.state.DemoData.Content_Title,
        Event_Description: this.state.DemoData.Content_Title,
        PhysicalContents: {
          Phy_ID: this.state.DemoData.Content_ID,
          Phy_Description: this.state.DemoData.Content_Description,
          Phy_Status: this.state.DemoData.Content_Status,
          Phy_LeadTime: 0,
          Phy_TAOkta_TemplateName:
            this.state.DemoData.PhyContent_TA_OKTA_TemplateName,
        },
        Is_HackshackReq: this.props.Is_Hackshack,
        Is_TMEIndividualReq: this.props.Is_TMEIndi,
        Is_TA_OKTAReq: this.props.Is_TAOKTA,
        Is_GLApp_Req: this.props.Is_GLApp,
        Is_OpsRampApp_Req: this.props.Is_OpsRampApp,
        Is_MistApp_Req: this.props.Is_MistApp,
        PhysicalEquipment: null,
        DemoEnvID:
          this.props.demo.Content_Environments != null &&
          this.props.demo.Content_Environments.length > 0
            ? this.props.demo.Content_Environments[0].PhyEquip_ID
            : null,
      };
      console.log("Request Payload: On demand Event Creation ", evtObj);
      this.setState({ bShowEvtCreationOnDemandLoader: true });
      callApiPostJson(endpoint, evtObj, token).then((data) => {
        console.log(
          "Response: On demand Event Creation ",
          JSON.stringify(data),
        );
        if (data && data.DupeMessage == null && !data.IsDuplicate) {
          this.setState({
            bShowEvtCreationOnDemandLoader: false,
            bTriggerActiveDemosCall: true,
          });
          logAccess(
            this.props.demo.Content_ID,
            this.props.demo.Content_Type,
            "On-Demand",
            this.props.calledBy,
            auth.getToken(),
          );
        } else if (data && data.DupeMessage != null && data.IsDuplicate) {
          this.setState({
            bShowEvtCreationOnDemandLoader: false,
            DupeMsg: data.DupeMessage,
            bShowDupeEvtOverlay: true,
          });
          //alert('Same Demo Event Already running....');
        } else if (data && data.DupeMessage != null && data.IsGLAppUnverified) {
          this.setState({
            bShowEvtCreationOnDemandLoader: false,
            DupeMsg: data.DupeMessage,
            // bShowDupeEvtOverlay: true,
            isGLusrVerified: true,
          });
          //alert('Same Demo Event Already running....');
        }
      });
    }
  }

  /* _HPEOnBackClick() {
    this.props.history.push("/"); */

  handleDemoEventTypeChange(value) {
    console.log("**EvtType Select List Clicked with selection below");
    console.log(value);
    console.log("**All List of Event Types below");
    console.log(this.state.eventTypeData);

    this.state.eventTypeData.map((evtTyp) => {
      if (evtTyp.EventType_Name == value) {
        this.setState({ EvtTypeSelected: evtTyp, demoEvtTypeVal: value });
      }
    });
  }

  loadEventTypes() {
    var endpoint = "/metadata/GetEventTypes";
    let token = auth.getToken();

    callApiGetJson(endpoint, token).then((data) => {
      //console.log('EventType data:' + data.toString());
      if (data !== undefined)
        // if (!this.state.UserActions.Equipment.Schedule) {
        data = data.filter((eventType) => {
          //var showThisRecord = false;
          if (eventType && eventType.EventType_ID !== 4)
            //4 = downtime
            return eventType;
        });
      //}
      this.setState({
        eventTypeData: data,
        isEvtListDisabled: false,
      });
    });
  }

  _onSFDCOpptyIdSubmit() {
    //this.state.oppoIdChecked = true;
    //This will do an fetch to API to validate SFDC ID

    console.log("_onSFDCOpptyIdChange - value: " + this.state.OppID);
    //this.oppoIdChecked = true;
    if (this.state.OppID) {
      if (this.state.OppID.length < 20 && this.state.OppID.length > 2) {
        this.setState({ showSFDCValidating: true });
        //don't call this unless they actually put something in there.
        var endpoint = "/SFDC/GetSFDCValidation?OptyId=" + this.state.OppID;
        let token = auth.getToken();

        callApiGetJson(endpoint, token).then((data) => {
          if (data !== undefined) {
            console.log(data);

            if (data.SRC_OPTY_SHRT_UID != null) {
              var Event_OpportunityID = data.SRC_OPTY_SHRT_UID;

              this.setState({
                // Event_OpportunityID: Event_OpportunityID,
                OppID: Event_OpportunityID,
                showSFDCValidating: false,
                errorInValidation: false,
                stickMessage: "Validation Successful",
                SubmitLabel: "Validation Successful",
              });
            } else {
              var Event_OpportunityID = undefined;
              this.setState({
                //message: data.Message[0], //keep validating screen up so they see userMessage.
                stickMessage: data.Message[0],
                showSFDCValidating: false,
                OppID: Event_OpportunityID,
                errorInValidation: true,
                SubmitLabel: "Invalid-OPP ID",
                // Event_OpportunityID: Event_OpportunityID,
              });
            }
          } else {
            var Event_OpportunityID = undefined;
            this.setState({
              OppID: Event_OpportunityID,
              showSFDCValidating: false,
              //message: "Error validating SFDC OPP ID.",
              stickMessage: "Error validating SFDC OPP ID.",
              errorInValidation: true,
            });
          }
        });
      }
    }
  }

  render() {
    var bSHowDupeWarning = this.state.bShowDupeEvtOverlay;
    var bshowGLUsrwarning = this.state.isGLusrVerified;
    var genmsg =
      this.state.DupeMsg != undefined
        ? this.state.DupeMsg
        : "Error in running this demo event at this time";
    console.log("Duplicate status is ", bSHowDupeWarning);
    if (this.state.bShowDupeEvtOverlay || this.state.isGLusrVerified) {
      console.log("Duppee status message is ", genmsg);
    }
    var SFDCtoBeShown = true;
    if (this.state.UserInfo.UserAppRoles) {
      var CustOne = this.state.UserInfo.UserAppRoles.find(
        (ar) => ar.AppRoleName === "HPE Customer",
      );
      if (CustOne !== undefined) {
        console.log("Customer App Role Obj is", CustOne);
        SFDCtoBeShown = false;
      }
    }

    console.log("User Obj is ", this.state.UserInfo);
    console.log("User App Roles are ", this.state.UserInfo.UserAppRoles);
    console.log("SFDCToBeShown flag is", SFDCtoBeShown);

    var OnDemandLabel = this.state.SubmitLabel;

    var EvtTypeList = undefined;
    var isEvtTypeDisabled = this.state.isEvtListDisabled;

    var bshowSFDCValidationON = this.state.showSFDCValidating;
    var bIssfdcvalidatrionError = this.state.errorInValidation;
    var sfdcvalidationmsg = this.state.stickMessage;

    var bTriggerLauching = this.state.bTriggerActiveDemosCall;

    var isSubmitNotEnabled = true;

    if (
      (this.state.stickMessage === "Validation Successful" ||
        this.state.NoOppIDReason) &&
      !this.state.bShowEvtCreationOnDemandLoader &&
      this.state.CustomerName &&
      this.state.EvtTypeSelected
    ) {
      isSubmitNotEnabled = false;
    }

    /*     if (
       !this.state.bShowEvtCreationOnDemandLoader &&
      this.state.CustomerName &&
      this.state.EvtTypeSelected &&
      !SFDCtoBeShown
    ) {
      isSubmitNotEnabled = false;
    }  */

    /* if (this.state.bTriggerActiveDemosCall) {
      console.log("**** Ya Ya Hippy Hippy Ya Ya Ya");
    } */
    /*     if (this.state.bShowDupeEvtOverlay) {
      console.log("DO NOT TRY TO BE OVER SMART IT IS DUPE");
      alert("Duplicate- Event already running....");
    } */

    if (this.state.eventTypeData) {
      EvtTypeList = new Array();
      this.state.eventTypeData.map((item) => {
        EvtTypeList.push(item.EventType_Name);
      });
    }

    console.log("EvtTypeData is ", this.state.eventTypeData);
    console.log("EvtType List is ", EvtTypeList);

    var OppIDVal =
      this.state.OppID != null || this.state.OppID != undefined
        ? this.state.OppID
        : "";
    console.log("Opportunity ID Text Value is", OppIDVal);

    return (
      // <Main flex="grow" fill="vertical" overflow="auto">
      <Layer animate modal position="center">
        <Box align="center" justify="center">
          <Box
            align="center"
            justify="center"
            background={{ color: "brand" }}
            fill="horizontal"
          >
            <Box
              align="center"
              justify="between"
              direction="row"
              gap="medium"
              fill="horizontal"
            >
              <Heading size="small" level="1" margin="small">
                OnDemand
              </Heading>
              <Button icon={<Close />} secondary onClick={this.props.hide} />
            </Box>
            <Text size="xlarge">{this.props.demo.Content_Title}</Text>
          </Box>
          <Box
            align="stretch"
            justify="start"
            direction="column"
            pad="medium"
            gap="medium"
            fill="horizontal"
          >
            <Grid>
              <Text>Demo Type</Text>
              <SingleSelect
                value={this.state.demoEvtTypeVal}
                placeholder="Select Demo-Event Type"
                options={EvtTypeList}
                disabled={isEvtTypeDisabled}
                onChange={this.handleDemoEventTypeChange}
              />
            </Grid>
            <Grid>
              <Text>Customer Name</Text>
              <TextInput
                value={this.state.CustomerName}
                onChange={(event) =>
                  this.handleCustomerName(event.target.value)
                }
              />
            </Grid>
          </Box>
          {SFDCtoBeShown && (
            <Box
              align="stretch"
              justify="start"
              gap="xsmall"
              fill="horizontal"
              pad={{ left: "medium", top: "small" }}
              direction="row"
              border={{ style: "dashed" }}
            >
              <Grid rows="xxsmall">
                <Text size="medium">SalesForce OPP Id:</Text>
                <TextInput
                  //defaultValue="OPE-"
                  placeholder="OPE-xxxxxxxxxx"
                  value={OppIDVal}
                  onChange={(event) => this.handleOppID(event.target.value)}
                />
                <Box
                  align="center"
                  justify="center"
                  hoverIndicator={{ image: "url('')" }}
                  wrap={false}
                >
                  <Tip
                    plain
                    content={
                      <Box
                        pad="small"
                        gap="small"
                        width={{ max: "small" }}
                        round="small"
                        background="background-front"
                        responsive={false}
                      >
                        <Text weight="bold" color="red">
                          Warning !
                        </Text>
                        <Text size="small">
                          Demo Event without OPP ID may be cancelled, please
                          secure your slot by providing OPP ID
                        </Text>
                      </Box>
                    }
                    dropProps={{ align: { left: "right" } }}
                  >
                    <CheckBox
                      label="I dont have an OPP Id"
                      toggle
                      checked={this.state.NoOppIDChecked}
                      //disabled={this.state.errorInValidation}
                      onChange={(event) =>
                        this.setOppIDChecked(event.target.checked)
                      }
                    />
                  </Tip>
                </Box>
              </Grid>
              <Box
                align="start"
                justify="center"
                pad="medium"
                overflow="visible"
              >
                {/* <Stack fill={false}> */}
                {!this.state.errorInValidation &&
                this.state.OppID &&
                this.state.stickMessage === "Validation Successful" ? (
                  <Box
                    align="center"
                    justify="center"
                    pad="xsmall"
                    background={{ color: "brand" }}
                    border={{ color: "white", size: "small" }}
                    round="full"
                  />
                ) : (
                  <Box
                    align="center"
                    justify="center"
                    pad="xsmall"
                    background={{ color: "red" }}
                    border={{ color: "white", size: "small" }}
                    round="full"
                  />
                )}
                <Button
                  label={
                    this.state.showSFDCValidating ? (
                      <Box
                        direction="row"
                        gap="small"
                        justify="center"
                        align="center"
                      >
                        <Spinner size="small" color="brand" />{" "}
                        <Text>Validating..</Text>
                      </Box>
                    ) : (
                      OnDemandLabel
                    )
                  }
                  primary={false}
                  icon={<Validate />}
                  secondary
                  disabled={bshowSFDCValidationON}
                  active={false}
                  hoverIndicator={{ opacity: "medium" }}
                  reverse={false}
                  onClick={this._onSFDCOpptyIdSubmit}
                />
                {/* </Stack> */}
              </Box>
            </Box>
          )}
          <Box
            align="center"
            justify="center"
            direction="row"
            gap="large"
            margin="medium"
          >
            <Button
              label={
                this.state.bShowEvtCreationOnDemandLoader ? (
                  <Box
                    direction="row"
                    gap="small"
                    justify="center"
                    align="center"
                  >
                    <Spinner size="small" color="brand" />{" "}
                    <Text>Creating demo event..</Text>
                  </Box>
                ) : (
                  "Submit"
                )
              }
              //active={false}
              primary
              reverse
              icon={<Console />}
              disabled={isSubmitNotEnabled}
              onClick={this._handleEventRequestOnDemand}
            />
            {bTriggerLauching && (
              <Launchdemospinner
                hide={this._HideLauncher}
                isDemoGuide={this.props.demo.DemoGuid_DocID ? true : false}
                demoGuideID={
                  this.props.demo.DemoGuid_DocID
                    ? this.props.demo.DemoGuid_DocID
                    : null
                }
              />
            )}
            {bSHowDupeWarning && !bshowGLUsrwarning && (
              <InfoWarning
                hide={this._hideInfoWarning}
                message={genmsg}
                isGLUsrIssue={false}
              />
            )}
            {bshowGLUsrwarning && !bSHowDupeWarning && (
              <InfoWarning
                hide={this._hideInfoWarning}
                message={genmsg}
                isGLUsrIssue={true}
              />
            )}
          </Box>
        </Box>
      </Layer>
      // </Main>
    );
  }
}

export default LaunchLiveDemo;
